export class RegExpUtil {
    static test(pattern, value) {
        let regExp = new RegExp(pattern);
        return regExp.test(value);
    }
    static regExp(pattern) {
        return new RegExp(pattern);
    }
}
